import { Col, Row } from "antd";
import {
  InputField,
  SearchInput,
  SubmitButton,
  TextComponent,
} from "../../../../../../components";
import styles from "./SeatingTable.module.css";
import { BsChevronRight } from "react-icons/bs";
import { useEffect, useRef, useState } from "react";
import Modal from "../../../../../../components/modal/Modal";
import { tables, people, TableModal } from "./LocalComp";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { EventPlanningMiddleware } from "../../../../../../Store/Middlewares/EventPlanningMiddleware";

const LeftCol = ({ setguests }) => {
  const SeatingArrangement = useSelector(
    (state) => state.EventPlanningReducer.Seating
  );

  const tableStats = [
    { label: "Tables", value: SeatingArrangement?.tables?.table_count },
    { label: "Seats", value: SeatingArrangement?.tables?.seat_count },
    { label: "Vacant", value: SeatingArrangement?.tables?.vacant_count },
  ];

  console.log("SeatingArrangement?.tables?.tables", SeatingArrangement);

  return (
    <div className={styles.leftCol}>
      <Row>
        <TextComponent textClass={styles.roomTitle}>
          Ceremony Room
        </TextComponent>
      </Row>
      <Row className={styles.statsRow}>
        {tableStats?.map((stat) => (
          <Col key={stat?.label}>
            <Row style={{ flexDirection: "column", color: "#222b45" }}>
              <TextComponent textClass={styles.statValue}>
                {stat.value}
              </TextComponent>
              <TextComponent textClass={styles.statLabel}>
                {stat.label}
              </TextComponent>
            </Row>
          </Col>
        ))}
      </Row>
      {SeatingArrangement?.tables?.tables?.map((table, index) => (
        <Row
          className={styles.tableRow}
          key={table?.id}
          onClick={() =>
            setguests({ guests: table?.guests, index, tableName: table?.name })
          }
        >
          <Col xs={22}>
            <Row>
              <TextComponent textClass={styles.tableName}>
                {table.name}
              </TextComponent>
            </Row>
            <Row className={styles.seatsInfoRow}>
              <Col xs={12} sm={7}>
                <TextComponent textClass={styles.tableSeats}>
                  {table.seats} Seats
                </TextComponent>
              </Col>
              <Col
                xs={12}
                sm={9}
                style={{ display: "flex", alignItems: "center", gap: "3px" }}
              >
                <div className={styles.assignedCircle}></div>
                <TextComponent textClass={styles.tableAssigned}>
                  {table.assigned} Assigned
                </TextComponent>
              </Col>
              <Col
                xs={12}
                sm={8}
                style={{ display: "flex", alignItems: "center", gap: "3px" }}
              >
                {table.vacant > 0 ? (
                  <div className={styles.vacantCircle}></div>
                ) : (
                  <div className={styles.zeroVacantCircle}></div>
                )}
                <TextComponent
                  textClass={
                    table.vacant > 0
                      ? styles.tableVacant
                      : styles.tableZeroVacant
                  }
                >
                  {table.vacant > 0 ? `${table.vacant} Vacant` : "0 Vacant"}
                </TextComponent>
              </Col>
            </Row>
          </Col>
          <Col xs={1}>
            <TextComponent textClass={styles.rightIcon}>
              <BsChevronRight />
            </TextComponent>
          </Col>
        </Row>
      ))}
    </div>
  );
};

const RightCol = ({ guests, setguests }) => {
  const { state } = useLocation();

  const dispatch = useDispatch();

  const EventDetails = state?.eventData;
  return (
    <div className={styles.rightCol}>
      <Row className={styles.contentRightHeader}>
        <Col>
          <TextComponent textClass={styles.headerTitle}>
            {guests?.tableName}
          </TextComponent>
        </Col>
        <Col>
          <TextComponent textClass={styles.headerGuests}>
            {guests?.guests?.length > 0 && guests?.guests?.length} Guests
          </TextComponent>
        </Col>
      </Row>
      <Row className={styles.peopleInfoRow}>
        {guests?.guests?.map((person, i) => (
          <Col xs={24}>
            <Row className={styles.singlePersonRow}>
              <Col sm={2} className={styles.personIndexCol}>
                <TextComponent textClass={styles.personIndex}>
                  {i + 1}
                </TextComponent>
              </Col>
              <Col xs={24} sm={9}>
                <TextComponent textClass={styles.personName}>
                  {person.name}
                </TextComponent>
              </Col>
              <Col xs={24} sm={9} xl={10}>
                <TextComponent textClass={styles.personRelation}>
                  {person.relation}
                </TextComponent>
              </Col>
              <Col
                xs={24}
                sm={4}
                lg={4}
                xl={3}
                style={{ cursor: "pointer" }}
                onClick={() =>
                  dispatch(
                    EventPlanningMiddleware.removeGuest({
                      event_id: EventDetails?.id,
                      user_id: person?.id,
                    })
                  ).then((data) => {
                    setguests({
                      ...guests,
                      guests: data?.tables?.tables?.[guests.index]?.guests,
                    });
                  })
                }
              >
                <TextComponent textClass={styles.personRemove}>
                  Remove
                </TextComponent>
              </Col>
            </Row>
          </Col>
        ))}
      </Row>
    </div>
  );
};

const SeatingTable = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [allTables, setAllTables] = useState(tables);

  // const EventDetails = useSelector(state => state.EventReducer.EventDetails);

  const { state } = useLocation();

  const EventDetails = state?.eventData;

  const [guests, setguests] = useState([]);

  const [loading, setloading] = useState(true);
  const dispatch = useDispatch();
  const timeout = useRef();

  useEffect(() => {
    dispatch(
      EventPlanningMiddleware.guestGroups({
        name: "",
        event_id: EventDetails?.id,
      })
    );
    dispatch(
      EventPlanningMiddleware.eventTables({ id: EventDetails?.id, name: "" })
    )
      .then((data) => {
        setguests({
          guests: data?.tables?.tables?.[0]?.guests,
          index: 0,
          tableName: data?.tables?.tables?.[0]?.name,
        });
        setloading(false);
      })
      .catch(() => setloading(false));
  }, []);

  const onSearch = (val) => {
    clearTimeout(timeout.current);
    timeout.current = setTimeout(() => {
      setloading(true);
      dispatch(
        EventPlanningMiddleware.eventTables({ id: EventDetails?.id, name: val })
      )
        .then((data) => {
          setguests({
            guests: data?.tables?.tables?.[0]?.guests,
            index: 0,
            tableName: data?.tables?.tables?.[0]?.name,
          });
          setloading(false);
        })
        .catch(() => setloading(false));
    }, 1500);
  };

  // useEffect(() => {
  //   clearTimeout(errorTimeout.current);
  //   errorTimeout.current = setTimeout(() => {
  //     seterror("");
  //   }, 2500);
  // }, [error]);

  return (
    <>
      <Row className={styles.searchRow} gutter={16}>
        <Col xs={24} sm={16} lg={18}>
          <SearchInput
            placeholder="Search"
            onChange={(e) => onSearch(e.target.value)}
          />
        </Col>
        <Col xs={24} sm={8} lg={6}>
          <SubmitButton
            title="+ Add Table"
            outline={true}
            btnClass={styles.searchBtn}
            onClick={() => setModalOpen(true)}
          />
        </Col>
      </Row>
      <Row className={styles.contentRow} gutter={8}>
        <Col xs={24} lg={9} xl={7}>
          <LeftCol setguests={setguests} />
        </Col>
        <Col xs={24} lg={15} xl={17}>
          <RightCol guests={guests} setguests={setguests} />
        </Col>
      </Row>
      {modalOpen && (
        <Modal
          isModalOpen={modalOpen}
          setIsModalOpen={setModalOpen}
          closable={true}
          // pinkBg={true}
          // wideModal={true}
          className={styles.modalContent}
        >
          <TableModal setAllTables={setAllTables} setModalOpen={setModalOpen} />
        </Modal>
      )}
    </>
  );
};

export default SeatingTable;
